import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { Observable } from 'rxjs';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';
import { NewUserCreationWarningDialogComponent } from '../pop-ups/new-user-creation-warning-dialog/new-user-creation-warning-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { E } from '@angular/cdk/keycodes';

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  public isOpen: boolean = false;
  public isLoading: boolean = false;
  public contractListHeader:any = [];
  public contractListData:any = [];
  public contractVersionList:any = [];
  public contractListPage:number = 1;
  public contractListTotalPage:number = 1;

  public access:any = {};

  public cid:string = "";
  public dataSaving:boolean = false;
  public showDataSaving:boolean = false;
  public contractUUid:string = "";

  public contractQuoteSavePayloadObject:any = {};
  public contractQuoteSavePrevPayloadObject:any ="";
  public contractSaveId:any = "";
  public isShowDownload:boolean = true;
  public isFormReload:boolean=false;
  public isShowPreview:boolean=true;
  
  public backTrack:string="";
  public isGlobalSearchShow:boolean=false;

  public updateContractRelatedFieldEmitter = new EventEmitter<any>();
  public onContractDetailsReload = new EventEmitter();
  public isReloadFormEmitter = new EventEmitter<any>();
  public headerSearchEventEmitter = new EventEmitter<any>();
  
  constructor(private apiRequest: ApiRequestService,
    public notifier:NotifierService,
    private dialog: MatDialog,
    private router: Router
  ) { }

  getContractListData(query?){
    this.contractListApiCall(query).subscribe((res:any) =>{
      if(res && res.status){
        this.setHeaders(res.headers);
        this.contractListPage = Number(res.page);
        this.contractListTotalPage = res.total_page;
        if (this.contractListPage == 1) {
          this.contractListData = res.data;
        }else{
          this.contractListData = [...this.contractListData,...res.data];
        }
        
      }else{
        this.notifier.notify('error',res.message);

      }
      
    });
  }

  setHeaders(header){
    this.contractListHeader = [];
    Object.keys(header).forEach((key) => {
      this.contractListHeader.push({'label':header[key]['label'],'key':key});
    });
  }

  onSendForApproval(uuid){
    this.sendToApprovalAndClient(uuid).subscribe((result) => {
      if (result["status"] == 1) {
        this.notifier.notify('success',result["message"]);
        // this.notifier.notify('success','Sent for approval successfully !');
      }else{
        this.notifier.notify('error',result["message"]);
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }
  onShareWithClient(body){
    this.shareToClient(body).subscribe((result) => {
      if (result["status"] == 1) {
        // this.notifier.notify('success','Shared with Client successfully !');
        this.notifier.notify('success',result["message"]);
        this.router.navigate(['/contract/details/'+this.contractSaveId]);
        if (body && body.navigateTo && body.navigateTo != "") {
          this.router.navigate([body.navigateTo]);          
        }else{
          this.onContractDetailsReloadEmitter();
        }
      }else if (result["status"] == 2) {
        let newUsers = result["data"].map((user:any) => user).join(", ");
        // if (result["data"] && result["data"].length > 1) {
        //   result["data"].forEach((user:any,index) => {
        //     newUsers += user;
        //     if (index == result["data"].length - 1) {
        //       newUsers += " and ";
        //     }else if (index < result["data"].length - 2) {
        //       newUsers += ", ";
        //     }
        //   });
        // }else{
        //   newUsers = result["data"][0];
        // }
        result["data"].forEach((user:any) => {});
        const dialogRef = this.dialog.open(NewUserCreationWarningDialogComponent, {
                width: '500px',
                height: '250px',
                disableClose :true,
                data:{
                  cid:this.cid,
                  uuid:this.contractSaveId,
                  users:newUsers,
                  orgName:result["org_name"] || "",
                }
              });
              dialogRef.afterClosed().subscribe((result) => {
                if (result && result === "confirmed") {
                  let nBody = body;
                  nBody['allowedAccessContractUsers'] = true;
                  this.onShareWithClient(nBody)
                }
              });
      }else{
        this.notifier.notify('error',result["message"]);
        // this.notifier.notify('error','Something went wrong !');
      }
    }, err => {
      this.notifier.notify('error','Something went wrong !');
    })
  }

  onContractDetailsReloadEmitter(){
    this.onContractDetailsReload.emit();
  }

  saveContractQuotePayload(){
    this.dataSaving = true
    this.showDataSaving = true
    this.isLoading = true;
    this.saveContractQuotePayloadApiCall().subscribe((res:any) => {
      if(res && res.status  && res.status == 1){
        this.contractSaveId = res.id || "";
        this.dataSaving = false;
        this.isShowPreview = res.show_preview ? res.show_preview : false;
        this.cid = res.cid;
        this.access = res['access'];
        if (!(this.contractUUid && this.contractUUid !="")) {
          this.contractUUid = res.id;
          this.router.navigate(['/contract/request/'+res.id]);
        }
        if(this.isFormReload){
          this.isFormReload = false;
          this.isReloadFormEmitter.emit({"uuid":res.id});
        }
        this.resetContractQuotePayload();
      }else if(res && res.status  && res.status == 2){
        this.contractSaveId = res.id || "";
        this.dataSaving = false;
        this.access = res['access'];
        this.isShowPreview = res.show_preview ? res.show_preview : false;
        this.updateContractRelatedFieldEmitter.emit(res);
        if(this.isFormReload){
          this.isFormReload = false;
          this.isReloadFormEmitter.emit({"uuid":res.id});
        }
        this.resetContractQuotePayload();
      }else{
        this.notifier.notify('error',res.message);
        this.dataSaving = false;
        this.showDataSaving = false
      }
      this.isLoading = false;
    })
  }

  resetContractQuotePayload(){
    this.contractQuoteSavePayloadObject = {};
    this.contractQuoteSavePrevPayloadObject = "";
  }

  contractListApiCall(query?):Observable<any> {
    let opt = {};
    if(query)opt['query'] = query;
    return this.apiRequest.request('GET','/v2/contract/list',{},opt);
  }

  getContractPreview(query?):Observable<any> {
    let opt = {};
    if(query)opt['query'] = {"version":query.version};
    return this.apiRequest.request('GET','/v2/contract/preview/pdf/'+query.uuid,{},opt);
  }

  getContractDownloadUrl(query?):Observable<any> {
    let opt = {};
    if(query)opt['query'] = {"version":query.version};
    return this.apiRequest.request('GET','/v2/contract/download/'+query.uuid,{},opt);
  }

  getContractForm(query): Observable<any> {
    let opt = {};
    if(query)opt['query'] = query;
    return this.apiRequest.request('GET','/v2/contract/list/form',{},opt);
  }

  getContractDetails(uuid): Observable<any> {
    return this.apiRequest.request('GET','/v2/contract/contractData/'+uuid);
  }

  getContractQuoteDetails(uuid,version?:string): Observable<any> {
    let opt = {};
    if(version && version!='')opt['query'] = {"version":version};
    return this.apiRequest.request('GET','/v2/contract/contractDataDetails/'+uuid,{},opt);
  }
  
  sendToApprovalAndClient(uuid): Observable<any> {
    return this.apiRequest.request('POST','/v2/contract/sendContract/'+uuid,{});
  }

  shareToClient(body): Observable<any> {
    return this.apiRequest.request('POST','/v2/contract/sendContract/'+body.uuid,body);
  }

  signContract(body): Observable<any> {
    return this.apiRequest.request('POST','/v2/contract/accept/'+body.uuid,body);
  }

  onDiscardContractVersion(body): Observable<any> {
    return this.apiRequest.request('POST','/v2/contract/versionDiscard/'+body.uuid,body);
  }

  saveContractQuotePayloadApiCall(): Observable<any> {
    let body = {data:this.contractQuoteSavePayloadObject};
    if(this.contractSaveId){
      body['id'] = this.contractSaveId;
    }
    return this.apiRequest.request('POST','/v2/contract/saveContract',body);
  }

  backToTrack(){
    if(this.backTrack && this.backTrack != ""){
      if(this.backTrack == "contract-list"){
        this.router.navigate(['/contract']);
      }else if(this.backTrack == "contract-details"){
        this.router.navigate(['/contract/details/'+this.contractSaveId]);
      }else if(this.backTrack == "contract-preview"){ 
        this.router.navigate(['/contract/preview/'+this.contractSaveId]);
      }else if(this.backTrack == "contract-request"){ 
        this.router.navigate(['/contract/request/'+this.contractSaveId]);
      }else{
        this.router.navigate(['/contract']);
      }
      this.backTrack = "";
    }else{
      this.router.navigate(['/contract']);
    }

  }
}
